module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = tost;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "successTost", function() { return successTost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorTost", function() { return errorTost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warnTost", function() { return warnTost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "infoTost", function() { return infoTost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
function tost(info){var tost=document.querySelector('#tost');var frame=document.querySelector('#client')||document.querySelector('#web')||document.querySelector('body');if(!tost){tost=document.createElement('div');tost.id='tost';tost.classList.add('tost');frame.appendChild(tost);}var item=document.createElement('div');var itemBg=document.createElement('i');var itemText=document.createElement('span');item.appendChild(itemBg);item.appendChild(itemText);item.classList.add('tost-item');var msg='';var time=2;var type='success';if(typeof info==='string'){msg=info;}else{msg=info.msg;time=info.time||time;type=info.type||type;}var msgNode=document.createTextNode(msg);itemText.appendChild(msgNode);item.classList.add(type);itemBg.classList.add('s-bg-'+type);tost.appendChild(item);setTimeout(function(){tost.removeChild(item);if(!tost.hasChildNodes()){frame.removeChild(tost);}},time*1000);}var typeTost=function typeTost(info,type){var newInfo={};if(typeof info==='string'){newInfo={type:type,msg:info};}else{newInfo=Object.assign({},info,{type:type});}tost(newInfo);};var successTost=function successTost(info){typeTost(info,'success');};var errorTost=function errorTost(info){typeTost(info,'error');};var warnTost=function warnTost(info){typeTost(info,'warn');};var infoTost=function infoTost(info){typeTost(info,'info');};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js